export default __webpack_public_path__ + "static/media/task-comment-mention.baa162c7.svg";